export enum ColumnLayoutSectionMode {

	MODE_FIXED = 'MODE_FIXED',
	MODE_FLEX = 'MODE_FLEX',
	MODE_ALIGN_RIGHT = 'MODE_ALIGN_RIGHT'

}
